<template>
    <div class="header">
        <div class="container-fluid">
            <!-- Hearer  -->
            <div class="mt-4">
                <div class="card">
                    <div class="card-body">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item fw-bolder">Master Data</li>
                                <li class="breadcrumb-item">Role </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <!-- Card  -->
            <div class="card mt-5">
                <div class="card-header">
                    <!-- Title -->
                    <h4 class="card-header-title">Role</h4>
                </div>
              <vue-good-table
                  :line-numbers="true"
                  :columns="columns"
                  :rows="list.data"
                  :sort-options="{
                        enabled: true,
                    }"
                  :total-rows="list.totalItems"
                  :pagination-options="{
                        enabled: true,
                        perPage: body.perPage,
                    }"
                  style-class="vgt-table border-0 table"
              >
                <template v-slot:columns.company="{ index, item }">
                  <span class=""> {{ item }}</span>
                </template>
                <!-- Loading -->
                <div slot="emptystate" class="text-center font-size-14">
                  No data available
                </div>
                <!-- Custom Rows -->

                <template slot="table-row" slot-scope="props">
                  <!-- Table Action -->
                  <span v-if="props.column.field == 'action'">
                    <b-button v-if="isUpdate" class="no-wrap btn-pill ml-2" variant="warning" size="sm" @click="updateData(props.row)">
                        <span class="fe fe-edit"></span>
                    </b-button>
                    <b-button v-if="isDelete" class="no-wrap ml-2" variant="danger" style="margin-left: 5px" size="sm"
                              @click="deleteData(props.row.id)">
                        <span class="fe fe-trash-2"></span>
                    </b-button>
                  </span>
                </template>
              </vue-good-table>
            </div>

          <b-modal id="modal-1" hide-footer title="Role Management Form">
            <form ref="myFormSave" @submit.prevent="save()">
              <div class="form-group">
                <label>Role Name <span class="text-danger">*</span></label>
                <input
                    type="text"
                    v-model="roleName"
                    class="form-control"
                    placeholder="Role Name"
                    v-validate="'required'"
                    name="Role Name"
                />

                <span class="text-sm text-danger" v-show="errors.has('Role Name')">{{
                    errors.first('Role Name')
                  }}</span>
              </div>
              <div class="form-group">
                <label>Description <span class="text-danger">*</span></label>
                <textarea
                    type="text"
                    v-model="description"
                    class="form-control"
                    placeholder="Description"
                    v-validate="'required'"
                    name="Description"
                    disabled
                />
                <span class="text-sm text-danger" v-show="errors.has('Description')">{{
                    errors.first('Description')
                  }}</span>
              </div>
              <div class="row gap-4 border-bottom mb-2">
                <b>Role Permission</b>
              </div>
              <div class="row gap-4 mb-1 border-bottom">
                <div class="col">
                  <div class="mb-1 "><b>Menu</b></div>
                </div>
                <div class="col">
                  <div class="d-flex mb-1">
                    <span class="mr-4">Read</span>
                    <span class="mr-4">Create</span>
                    <span class="mr-4">Update</span>
                    <span class="mr-4">Delete</span>
                  </div>
                </div>
              </div>
              <div v-for="menu in listMenu" :key="menu.id" class="row gap-4 mb-1 border-bottom">
                <div class="col">
                  <div class="mb-1 "><b>{{ menu.name }}</b></div>
                  <div v-for="menuSub in menu.childs" :key="menuSub.id" class="mb-2 ml-3">{{ menuSub.name }}</div>
                </div>
                <div class="col">
                  <div v-if="menu.childs.length > 0">
                    <div class="d-flex mb-1">
                      <span class="mr-4">&nbsp;</span>
                    </div>
                    <div v-for="menuSub in menu.childs" :key="menuSub.id">

                      <div v-if="menuSub.items.length > 0" v-for="authData in menuSub.items" class="d-flex mb-1" style="margin-right:-30px">

                        <b-checkbox
                            :name="`read-${menuSub.id}`"
                            class="mr-5"
                            :checked="authData.authorization.includes('read')"
                        ></b-checkbox>
                      <b-checkbox
                          :name="`create-${menuSub.id}`"
                          class="mr-5"
                          :checked="authData.authorization.includes('create')"
                      >
                      </b-checkbox>
                      <b-checkbox
                          :name="`update-${menuSub.id}`"
                          class="mr-5"
                          :checked="authData.authorization.includes('update')"
                      ></b-checkbox>
                      <b-checkbox
                          :name="`delete-${menuSub.id}`"
                          class="mr-5"
                          :checked="authData.authorization.includes('delete')"
                      ></b-checkbox>
                      </div>
                      <div v-if="menuSub.items.length < 1" class="d-flex mb-1" style="margin-right:-30px">
                        <b-checkbox
                            :name="`read-${menuSub.id}`"
                            class="mr-5"
                        ></b-checkbox>
                      <b-checkbox
                          :name="`create-${menuSub.id}`"
                          class="mr-5"
                      >
                      </b-checkbox>
                      <b-checkbox
                          :name="`update-${menuSub.id}`"
                          class="mr-5"
                      ></b-checkbox>
                      <b-checkbox
                          :name="`delete-${menuSub.id}`"
                          class="mr-5"
                      ></b-checkbox>
                      </div>
                  </div>
                </div>
                <div v-else>
                    <div v-if="menu.items.length > 0" v-for="authData in menu.items" class="d-flex mb-1" style="margin-right:-30px">
                      <b-checkbox
                          :name="`read-${menu.id}`"
                          class="mr-5"
                          :checked="authData.authorization.includes('read')"
                      ></b-checkbox>
                      <b-checkbox
                          :name="`create-${menu.id}`"
                          class="mr-5"
                          :checked="authData.authorization.includes('create')"
                      ></b-checkbox>
                      <b-checkbox
                          :name="`update-${menu.id}`"
                          class="mr-5"
                          :checked="authData.authorization.includes('update')"
                      ></b-checkbox>
                      <b-checkbox
                          :name="`delete-${menu.id}`"
                          class="mr-5"
                          :checked="authData.authorization.includes('delete')"
                      ></b-checkbox>
                    </div>
                    <div v-if="menu.items.length < 1" class="d-flex mb-1" style="margin-right:-30px">
                      <b-checkbox
                          :name="`read-${menu.id}`"
                          class="mr-5"
                      ></b-checkbox>
                    <b-checkbox
                        :name="`create-${menu.id}`"
                        class="mr-5"
                    ></b-checkbox>
                    <b-checkbox
                        :name="`update-${menu.id}`"
                        class="mr-5"
                    ></b-checkbox>
                    <b-checkbox
                        :name="`delete-${menu.id}`"
                        class="mr-5"
                    ></b-checkbox>
                    </div>
                </div>
                </div>
              </div>
              <div class="form-group float-end m-1 p-1">
                <button class="mt-2 btn btn-outline-light mr-2" type="button" @click="confirmAndCloseModal()">
                  Cancel
                </button>
                <button class="mt-2 btn btn-primary" type="submit" v-if="isLoading == false">Save</button>
                <button class="mt-2 btn btn-primary" type="button" disabled v-else>
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Loading...
                </button>
              </div>
            </form>
          </b-modal>
    </div>
</div>
</template>

<script>
import axiosIns from "@/api/axios";

export default {
name: "GentaGendis",
computed: {
    list() {
    return this.$store.getters["masterRole/listData"];
    },
},
data() {
    return {
      payload: {
        role_id: "",
        menu_id: "",
        authorization: []
      },
      roleName: "",
      description: "",
      authorization: {},
      menus: [],
      canAdd: false,
      canEdit: false,
      canDelete: false,
      body: {
          page: 1,
          limit: 10,
          order: "",
      },
      modalCreate: {
          roles_name: "",
          description: "",
      },
      modalUpdate: {
          roles_name: "",
          description: "",
      },
      id: "",
      isAdd: true,
      isLoading: false,
      listMenu: [],
      columns: [
          {
          label: "Role Name",
          field: "roles_name",
          sortable: false,
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle",
          },
          {
          label: "Description",
          field: "description",
          sortable: false,
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle",
          },
        {
          label: "Action",
          field: "action",
          sortable: false,
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold text-center",
          tdClass: "no-wrap color-secondary align-middle text-center",
        },
      ],
      rows: [
        {
          roles_name: 'Super Admin',
          description: 'Super Admin has access to all menu'
        },
        {
          roles_name: 'Admin',
          description: 'Admin has role to make budgeting'
        },
        {
          roles_name: 'User',
          description: 'User has role to view budgeting'
        },
        {
          roles_name: 'Viewer',
          description: 'Role to view budget'
        }
        ],
      isRead: false,
      isCreat: false,
      isUpdate: false,
      isDelete: false
    };
},

mounted() {
  this.checkPermission();
  this.getList();
  //this.getListMenu();
  this.role_id = localStorage.getItem('roles')
},
methods: {
    async checkPermission() {
      const roleName = localStorage.getItem("roles");
      const roleId = await axiosIns.get("/master-role/find-name?name=" + roleName);
      const menuId = await axiosIns.get("/master-menu/find-link?link=" + this.$route.path);
      const payloadPermission = {
        role_id: roleId.data.data[0]?.id || null,
        menu_id: menuId.data.data[0]?.id || null
      }
      const checkAuth = await axiosIns.post("/master-role/check-permission", payloadPermission);
      if(checkAuth.data.data?.authorization){
        this.isRead = checkAuth.data.data?.authorization.includes('read')
        this.isCreat = checkAuth.data.data?.authorization.includes('create')
        this.isUpdate = checkAuth.data.data?.authorization.includes('update')
        this.isDelete = checkAuth.data.data?.authorization.includes('delete')
      }
    },
    getList() {
      this.$store.dispatch('masterRole/GET_LIST_DATA', this.body)
    },
    /*async getListMenu() {
      try {
        const response = await axiosIns.get("/master-role/menu");
        this.listMenu = response.data.data;
      } catch (error) {
        console.error("Failed to fetch year options:", error);
      }
    },*/
    saveAdd() {
      this.$validator.validateAll().then(async (res) => {
        if (!res) return false;

        try {
        this.isLoading = true;
        this.$store
            .dispatch("role/CREATE_DATA", this.modalCreate)
            .then((resp) => {
            this.$swal("Saved", "Your input has been saved", "success").then(
                (resp) => {
                this.isLoading = false;
                (this.modalCreate = {
                    roles_name: "",
                    description: "",
                }),
                    this.getList();
                this.$bvModal.hide("modal-1");
                }
            );
            });
        } catch (error) {
        this.$swal("Error", "Error while add data", "error");
        }
      });
    },

    /*saveUpdate() {
    let body = {
        id: this.id,
        data: { ...this.modalUpdate },
    };
    this.isLoading = true;
    this.$store
        .dispatch("role/UPDATE_DATA", body)
        .then((resp) => {
        this.$swal("Saved", "Your input has been saved", "success").then(
            (resp) => {
            this.isLoading = false;
            (this.modalUpdate = {
                roles_name: "",
                description: "",
            }),
                this.getList();
            this.$bvModal.hide("modal-1");
            }
        );
        })
        .catch((err) => {
        this.$swal("Error", "Error while update data", "error");
        });
    },*/
    async updateData(rows) {
      this.$bvModal.show("modal-1");
      this.isAdd = false;
      this.payload.role_id = rows.id
      this.roleName = rows.roles_name;
      this.description = rows.description;
      this.id = rows.id;

      const response = await axiosIns.get("/master-role/menu/" +rows.id);
      this.listMenu = response.data.data;
      console.log("isi menu: ", this.listMenu);
      //this.processMenus(this.listMenu, rows.roles_name || []);
    },
    getAuthorizationArray(menuId) {
      const auth = [];
      const perms = this.authorization[menuId];
      console.log("perms: ", perms);
      /*if (perms) {
        if (perms?.read) auth.push('read');
        if (perms?.create) auth.push('create');
        if (perms?.update) auth.push('update');
        if (perms?.delete) auth.push('delete');
      }*/
      return auth;
    },

    deleteData(id) {
    this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
    }).then((result) => {
        if (result.isConfirmed) {
        this.$store
            .dispatch("role/DELETE_DATA", id)
            .then((resp) => {
            this.getList();
            this.$swal("Deleted!", "Your file has been deleted", "success");
            })
            .catch((resp) => {
            this.$swal("Error", "Error while delete data", "error");
            });
        }
    });
    },
    // filter
    filterPage() {},
    sorting() {},
    // Pagination
    onPageChange(payload) {
    this.body.limit = payload.currentPerPage;
    this.body.page = payload.currentPage;
    },
    async save() {
    this.$validator.validateAll().then(async (res) => {
      if (!res) return false;

      try {
        this.isLoading = true;

        //const payloads = [];
        const payloads = {
          id: "",
          role_menus: []
        };
        const rolesPayloads = [];
        const form = this.$refs.myFormSave;
        const formData = new FormData(form);
        const data = {};
        const dtPayload = [];
        let i = 0;
        formData.forEach((value, key) => {
          data[key] = value;
          const dt = key.split("-");
          if(i > 1){
            dt.push(value)
          }
          dtPayload.push({
            menu_id: dt[1],
            authorization: dt[0],
          });
          i++;
        });
        this.listMenu.forEach((value, key) => {
          const result = dtPayload.filter(item => parseInt(item.menu_id) === value.id);
          if(result.length > 0){
            const authorization = [];
            result.forEach((values, key) => {
              authorization.push(values.authorization);
            })
            rolesPayloads.push({
              menu_id: parseInt(value.id),
              authorization: authorization
            });
          }
        });

        this.listMenu.forEach((value, key) => {
          let v1 = 0
          if(value?.childs.length > 0){
            value?.childs.forEach((values, keys) => {
              const authorizationSub = [];
              const results = dtPayload.filter(item => parseInt(item.menu_id) === values.id);
              results.forEach((valuess, keyss) => {
                authorizationSub.push(valuess.authorization);
              })
              if(results.length > 0){
                rolesPayloads.push({
                  menu_id: parseInt(values.id),
                  authorization: authorizationSub
                });
              }
            });
          }
        });
        payloads.id = this.payload.role_id;
        payloads.role_menus = rolesPayloads;
        if(payloads){
          await this.$store.dispatch('masterRole/UPDATE_ROLE_MENUS_DATA', payloads).then(() => {
            this.$swal('Saved', 'Your input has been updated', 'success').then(async () => {
              await this.getList();
            });
          });
        }
      } catch (error) {
        console.error('Error saving data:', error);
        this.$swal('Error', 'Error while add data', 'error');
      }
      this.$bvModal.hide('modal-1');
      //this.isAdd = true;
      this.isLoading = false;
      this.reset();
    });
  },
    reset() {
      this.payload = {
        role_id: "",
        menu_id: "",
        authorization: []
      };
      this.roleName = "";
    },
    confirmAndCloseModal() {
      this.$swal({
        title: 'Confirm Close?',
        text: 'Are you sure you want to close this page?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$bvModal.hide('modal-1');
          this.reset();
        } else {
          this.reset();
        }
      });
    },
},
};
</script>
  